import { deleteFavourite, saveFavourite } from '@propertypal/shared/src/reducers/favourites';
import { useAppDispatch, AppDispatch } from '@propertypal/shared/src/reducers/store';
import { selectUser } from '@propertypal/shared/src/reducers/user';
import router from 'next/router';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

export const favouriteProperty =
  (dispatch: AppDispatch, loggedIn: boolean, propertyId?: number) =>
  async (favourited: boolean, mPropertyId: number = 0) => {
    const id = propertyId !== undefined ? propertyId : mPropertyId;

    if (!loggedIn) {
      const sourcePath = `shortlist?update=${id}&sourcePath=${window.location.pathname}`;
      await router.push(`/login?sourcePath=/${encodeURIComponent(sourcePath)}`);

      return false;
    }

    if (favourited) {
      return dispatch(saveFavourite(id));
    }

    return dispatch(deleteFavourite(id));
  };

const usePropertyFavourite = (propertyId?: number) => {
  const user = useSelector(selectUser);
  const dispatch = useAppDispatch();

  return useCallback(() => {
    return favouriteProperty(dispatch, user.loggedIn, propertyId);
  }, [user.loggedIn]);
};

export default usePropertyFavourite;
